<template>
    <div class="c-panel c-panel--small">
        <h3 class="margin-b-24">Wachtwoord vergeten</h3>

        <p>Vul hieronder je e-mailadres in. We sturen dan binnen enkele minuten een e-mail waarmee een nieuw wachtwoord kan worden aangemaakt.</p>

        <c-form @submit:valid="submit" ref="form">

            <c-input 
                type="email" 
                name="email"
                required
                v-model="email" 
                :label="'E-mailadres'" />

            <c-button class="c-btn--expanded margin-t-32 margin-b-16" type="submit">Wachtwoord aanvragen</c-button>

            <div class="text-center">
                <router-link :to="{name: 'login'}">Terug naar inloggen</router-link>
            </div>

        </c-form>
    </div>
</template>

<script>
import Form from '@mixins/Form';
import { ValidationError } from '@app/errors';

export default {
    mixins: [Form],
    data() {
        return {
            email: '',
        }
    },
    methods: {
        submit() {
             this.$xhr.post('/api/auth/password-recover', { email: this.email }).then( () => {
                    this.$router.push({name: 'password-forget-success'});
                }).catch( e => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    } else {
                        this.$refs.form.setErrors({email: ['E-mailadres niet gevonden']});
                    }
                    this.error = true;
                });
        }
    }
}
</script>